export const EARTH_TAXONOMY_ID = '58f7ed51dadb30820bb38782';

const defaultExport = { EARTH_TAXONOMY_ID };

export default defaultExport;
